import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";

const InjectMassage = (props) => <FormattedMessage {...props} id={props.id || "invalid id"} />;
export default injectIntl(InjectMassage, {
   withRef: false
});

//to get string without object, wrap component like this:
//  <FormattedMessage id={yourId}>
// {(formattedValue) => <Input placeholder={formattedValue}></Input>}
// </FormattedMessage>;
